module.exports = __webpack_public_path__ + "static/media/agricoach-bg.7c682d51.png";